import React from 'react';

import Tooltip from '@mui/material/Tooltip';

const scrollDismissEvents = ['scroll', 'wheel', 'touchmove'];

const ScrollDismissTooltip = ({ onClose, onOpen, open: controlledOpen, ...props }) => {
  const [uncontrolledOpen, setUncontrolledOpen] = React.useState(false);
  const isControlled = controlledOpen !== undefined;
  const open = isControlled ? controlledOpen : uncontrolledOpen;

  const closeTooltip = React.useCallback((event) => {
    if (!isControlled) {
      setUncontrolledOpen(false);
    }

    onClose?.(event);
  }, [isControlled, onClose]);

  React.useEffect(() => {
    if (!open) return undefined;

    const hideOnScroll = (event) => {
      closeTooltip(event);
    };

    scrollDismissEvents.forEach((eventName) => {
      window.addEventListener(eventName, hideOnScroll, true);
    });

    return () => {
      scrollDismissEvents.forEach((eventName) => {
        window.removeEventListener(eventName, hideOnScroll, true);
      });
    };
  }, [closeTooltip, open]);

  const handleOpen = React.useCallback((event) => {
    if (!isControlled) {
      setUncontrolledOpen(true);
    }

    onOpen?.(event);
  }, [isControlled, onOpen]);

  return (
    <Tooltip
      {...props}
      onClose={closeTooltip}
      onOpen={handleOpen}
      open={open}
    />
  );
};

export default ScrollDismissTooltip;
